import React from 'react';
import { useTranslation } from 'react-i18next';

import Line from './Line';
import { IDepositItem, ILineItem, OnUpdateLine } from './types';

interface IProps {
  onUpdate: OnUpdateLine;
  lines: ILineItem[];
  deposits: IDepositItem[];
}

export default function Lines({ onUpdate, lines, deposits }: IProps) {
  const { t } = useTranslation();

  if (lines.length === 0) {
    return (
      <div className="flex items-center justify-center py-8">
        <div>
          <span className="text-gray-600">{t('BasketIsEmpty')}</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="basket-lines">
        <div className="basket-lines-header basket-line-row">
          <div className="product">{t('ProductName')}</div>
          <div className="availability">{t('Availability')}</div>
          <div className="unit-count">{t('UnitCount')}</div>
          <div className="price">{t('Price')}</div>
        </div>
        {lines.map(line => (
          <Line key={line.lineId} onUpdate={onUpdate} {...line} />
        ))}
        {deposits.map((deposit, index) => (
          <div key={index} className="basket-line-row">
            <div className="image">
              {deposit.imageUrl && <img alt={deposit.depositName}
                className="max-h-full object-scale-down"
                src={deposit.imageUrl} />}
            </div>
            <div className="product font-bold">{deposit.depositName}</div>
            <div className="unit-count">
              <input
                type="number"
                value={deposit.unitCount}
                className="as-text w-16 h-8 px-1 text-center text-xs laptop:text-sm"
                readOnly
              />
            </div>
            <div className="price">
              <span className="text-price font-bold">{deposit.lineValue.formatted}</span>
              <span className="text-xs laptop:text-sm text-gray-400 font-medium">
                {deposit.unitCount}x {deposit.unitValue.formatted}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
